import { render, staticRenderFns } from "./DocumentFolderTreeList.vue?vue&type=template&id=13b81e5b"
import script from "./DocumentFolderTreeList.vue?vue&type=script&lang=js"
export * from "./DocumentFolderTreeList.vue?vue&type=script&lang=js"
import style0 from "./DocumentFolderTreeList.vue?vue&type=style&index=0&id=13b81e5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports